import { GetSlotsResponse } from '@/types/scheduling';

/**
 * Validates Cal.com configuration and returns error response if invalid
 */
export function validateCalConfig(
  calConfig: { eventTypeSlug: string; teamSlug?: string; username?: string; eventTypeId?: number } | null,
  context: string
): GetSlotsResponse | null {
  if (!calConfig) {
    console.error(`❌ No Cal.com config found for ${context}`);
    return {
      success: false,
      slots: [],
      error: 'Configuration Cal.com introuvable pour ce produit',
    };
  }
  return null;
}

/**
 * Validates that eventTypeId is present for first-timer bookings
 */
export function validateFirstTimerEventTypeId(
  isFirstTimer: boolean,
  eventTypeId: number | undefined,
  eventTypeSlug: string
): { success: false; error: string } | null {
  if (isFirstTimer && !eventTypeId) {
    console.error('❌ eventTypeId manquant dans cal_event_mappings pour first-timer', eventTypeSlug);
    return {
      success: false,
      error: 'Configuration Cal.com incomplète : eventTypeId manquant.',
    };
  }
  return null;
}

